import styled from "@emotion/styled";
import React from "react";
import { RecaptchaPolicy } from "../Recaptcha/RecaptchaPolicy";
import { Typography } from "../Typography";

export const FORM_DISCLAIMER_TEXT = `By creating an account you agree to receive Ecologi email updates about your impact, important related news and other ways to continue your climate journey. This includes our monthly newsletter. You can manage your preferences at any time.`;

const Disclaimer = styled(Typography)`
  margin-bottom: 20px;
  color: ${({ theme }) => theme.colors.charcoalLight};
`;

const FooterContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 24px;
`;

const WithBackgroundContainer = styled(FooterContainer)`
  border-radius: 8px;
  margin-top: 24px;
  padding: 32px;
  background-color: #f6f6f6;
`;

/** Contains disclaimer text. */
export const FormFooter = ({
  showRecaptchaPolicy = false,
  content = FORM_DISCLAIMER_TEXT,
  rightContent,
  withBackground = false,
}: {
  showRecaptchaPolicy?: boolean;
  content?: React.ReactNode;
  rightContent?: React.ReactNode;
  withBackground?: boolean;
}) => {
  const Container = withBackground ? WithBackgroundContainer : FooterContainer;

  return (
    <Container>
      <div>
        <Disclaimer use="dashboardMicroCopyRegular" as="p">
          {content}
        </Disclaimer>

        {showRecaptchaPolicy && <RecaptchaPolicy />}
      </div>
      {rightContent && rightContent}
    </Container>
  );
};
